import { render } from "./excursionPage.vue?vue&type=template&id=7e27dde1&scoped=true"
import script from "./excursionPage.vue?vue&type=script&lang=js"
export * from "./excursionPage.vue?vue&type=script&lang=js"

import "./excursionPage.vue?vue&type=style&index=0&id=7e27dde1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e27dde1"]])

export default __exports__